/* @generated */
import * as React from "react";
import { stackStyle, xSmallStyling, smallStyling, mediumStyling, largeStyling, xLargeStyling } from "./stack.css.esm.js";
import { mapResponsiveValue, atoms } from "../config/atoms.css.esm.js";
import { spacing } from "../config/spacing.esm.js";
import { getResponsiveStyling, alignToFlexAlign, justifyToFlexJustify } from "../config/responsive.esm.js";
import cx from "classnames";
/* empty css                 */const STYLE_VAR_MAPPING = {
  xsmall: xSmallStyling,
  small: smallStyling,
  medium: mediumStyling,
  large: largeStyling,
  xlarge: xLargeStyling
};
const Stack = ({
  children,
  className,
  gap = "0",
  style: outerStyle,
  nestedWrapperTag: NestedWrapperTag = "div",
  tagName: TagName = "div",
  align,
  justify,
  nestedWrapperHtmlAttributes,
  height,
  width,
  display,
  padding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  paddingX,
  paddingY,
  ...rest
}) => {
  const [responsiveClasses, varsStyle] = getResponsiveStyling({
    styleProps: gap,
    varMap: spacing,
    sizeToStylingMapping: STYLE_VAR_MAPPING
  });
  const innerCls = cx(responsiveClasses, stackStyle);
  const outerCls = cx(className);
  const styl = { ...outerStyle, ...varsStyle };
  const alignItems = align ? mapResponsiveValue(align, (value) => alignToFlexAlign[value]) : void 0;
  const justifyContent = justify ? mapResponsiveValue(justify, (value) => justifyToFlexJustify[value]) : void 0;
  return /* @__PURE__ */ React.createElement(
    NestedWrapperTag,
    {
      ...nestedWrapperHtmlAttributes,
      className: cx(atoms({ height, width }), outerCls)
    },
    /* @__PURE__ */ React.createElement(
      TagName,
      {
        className: cx(
          innerCls,
          atoms({
            display: display ? display : "block",
            flexDirection: "column",
            height,
            width,
            alignItems,
            justifyContent,
            padding,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
            paddingX,
            paddingY
          })
        ),
        style: styl,
        ...rest
      },
      children
    )
  );
};
export {
  Stack
};
